import { addImposterToUrl } from 'Utils';
import { ISelfReferralPingItem } from 'Interfaces/SelfServiceReferrals';
import { api } from '../axios';

const dataBaseURL = '/SelfServiceReferrals';

export const POLL_INTERVAL_MS = 10_000;
/** Fallback if server never returns Timeout (server timeout is 5 minutes). */
export const CLIENT_TIMEOUT_MS = 5 * 60 * 1000 + 30_000;

export const pingSelfReferralFiles = async (
  tickers: readonly string[],
): Promise<ISelfReferralPingItem[]> => {
  if (tickers.length === 0) return [];

  const params = new URLSearchParams();
  tickers.forEach((ticker) => params.append('tickers', ticker));

  const result = await api.get<ISelfReferralPingItem[]>(
    addImposterToUrl(
      `${dataBaseURL}/pingFileExisting?${params.toString()}`,
      false,
    ),
  );
  return result.data ?? [];
};
